'use client'
import { useTranslate } from '@repo/shared/hooks'
import {
  Card,
  Col,
  Row,
  Separator,
  Skeleton,
  Typography,
} from '@repo/ui/components'
import React, { Fragment } from 'react'
import { HistoryItem } from './history.item'
import { useAgentOtcGetHistory } from '@repo/services'
import { HistoryEmptyState } from './history.empty-state'

export const HistoryContainer = () => {
  const { t } = useTranslate()

  const { data: { data: { transactions } = {} } = {}, isLoading } =
    useAgentOtcGetHistory({
      skip: 0,
      limit: 3,
    })

  return (
    <Row className='min-h-screen items-start mb-8xl md:mb-3'>
      <Card className='flex-1'>
        <Typography size='sm' weight='bold'>
          {t('dashboardAgent_history_title')}
        </Typography>
        <Col>
          {isLoading && (
            <div className='space-y-2'>
              <Skeleton className='w-full h-20' />
              <Skeleton className='w-full h-20' />
              <Skeleton className='w-full h-20' />
            </div>
          )}
          {transactions?.map((transaction, index) => (
            <Fragment key={transaction.id}>
              {index !== 0 && <Separator />}
              <HistoryItem {...transaction} />
            </Fragment>
          ))}
          {transactions?.length === 0 && !isLoading && <HistoryEmptyState />}
        </Col>
      </Card>
    </Row>
  )
}
